import { useContext } from 'react';
import { IdentityPageContext } from './context';

const useIdentityPage = () =>
  useContext(IdentityPageContext);

export default useIdentityPage;
